<template>
    <div>
        <div v-if="!loading">
            <md-forms-form-builder v-if="showMode === 'form'"
                                   :count="true"
                                   :field-cols="fieldCols"
                                   :form-id="formId"
                                   :form-load-error-text="formLoadErrorText"
                                   :label-cols="labelCols"
                                   :language="language"
                                   :login-text="loginText"
                                   :login-url="loginUrl"
                                   :mode="mode"
                                   :page-id="pageId"
                                   :re-captcha-key="reCaptchaKey"
                                   :return-url="returnUrl"
                                   :send-text="sendText"
                                   :website-id="websiteId"
                                   @submitted="showResults"></md-forms-form-builder>
            <div v-else>
                <p>Total: {{ counter.countTotal }}</p>
                <div v-for="(item, index) in counter.items" :key="index">
                    <h3>{{ item.fieldName }}</h3>
                    <p v-for="(value, index) in item.values" :key="index">
                        {{ value.name }}: {{ value.count }} </p>
                </div>
            </div>
            <p class="mt-3">
                <button v-if="showMode === 'form'" class="btn btn-secondary" type="button" @click="showResults">
                    Resultate
                </button>
            </p>
        </div>
        <div v-else class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import MdFormsFormBuilder from './FormBuilder.vue';

export default {
    components: { MdFormsFormBuilder },
    props: {
        pageId: {
            type: String,
            required: true
        },
        websiteId: {
            type: String,
            required: true
        },
        formId: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        },
        fieldCols: {
            type: String,
            required: true
        },
        returnUrl: {
            type: String,
            default: ''
        },
        parentId: {
            type: String,
            default: ''
        },
        formLoadErrorText: {
            type: String,
            required: true,
        },
        sendText: {
            type: String,
            required: true
        },
        loginText: {
            type: String,
            required: true
        },
        loginUrl: {
            type: String
        },
        language: {
            type: String,
            required: true
        },
        reCaptchaKey: {
            type: String,
            default: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
        },
        mode: {
            type: String,
            default: 'entry'
        }
    },
    data() {
        return {
            showMode: "form",
            counter: {
                countTotal: 0,
                items: []
            },
            loading: false
        };
    },
    methods: {
        showResults() {
            this.loadCounter()
                .then(() => {
                    this.showMode = "results";
                });
        },
        loadCounter() {
            let self = this;
            return new Promise(function (resolve) {
                self.loading = true;
                Axios.get('/umbraco/mdforms/poll/GetCounter?formId=' + self.formId + '&language=' + self.language).then(response => {
                    self.counter = response.data;
                    self.loading = false;
                    resolve();
                }).catch(() => {
                    self.loading = false;
                });
            });

        }
    }
}
</script>